import React, { Fragment, useEffect, useState } from 'react'
import { BlobProvider } from '@react-pdf/renderer';
import { useShared } from '../../hooks/useShared'
import MainSection from '../../components/sections/MainSection';
import APopover from '../../components/partials/APopover';
import TariffPdf from './TariffPdf';
import { ToastContainer } from 'react-toastify';
import { Chip } from '@material-tailwind/react';
import AMenu from './AMenu';
import ASpinner from '../../components/partials/ASpinner';
import { useParams } from 'react-router-dom';
import QRGenerator from '../../components/qrcode/QRGenerator'
import PDFGenerateModal from '../../components/modals/PDFGenerateModal';

const TABLE_HEAD = ["شماره", "ID", "نام/ شرکت", 'اجناس', 'حالت تعرفه', "فایل", 'تاریخ', 'اقدامات'];

const breadcrumbs = [{ name: 'تعرفه‌ها', link: '/tariffs' }]

const searchInputFields = [
    { label: 'ID', name: 'tariff_id_number', type: 'text', roles: [1, 2, 4, 17], icon: 'text-outline', className: 'md:col-span-2', },
    { label: 'شرکت / نام', name: 'name', type: 'text', roles: [1, 2, 17], icon: 'text-outline', className: 'md:col-span-2', options: [] },
    { label: 'جنس', name: 'item', type: 'text', roles: [1, 2, 4, 17], icon: 'text-outline', className: 'md:col-span-2' },
    {
        label: 'حالت تعرفه', name: 'status', type: 'select', roles: [1, 2, 4, 17], icon: 'book-outline', className: 'md:col-span-2',
        options: [
            { value: 0, label: "منتظر آويز" },
            { value: 1, label: "منتظر تاييد" },
            { value: 2, label: "تکمیل" },
            { value: -1, label: "رد شده" },
        ]
    },
    { label: 'ايجاد کننده', name: 'creator_id', type: 'select', roles: [1, 2, 17], icon: 'text-outline', className: 'md:col-span-2', options: [] },
];


const csvHeaders = [
    { label: "#", key: "index" },
    { label: "Company/Name", key: "company" },
    { label: "Items", key: "items" },
    { label: "Date", key: "date" },
    { label: "Status", key: "status" },
    { label: "Added By", key: "creator_id" },
];


export default function Tariffs() {

    const { id } = useParams()
    const [union, setUnion] = useState(null)
    const { http, com,
        model, setModel, location,
        models, navigate, Num2persian, auth,
        generatePDF, setGeneratePDF, setShowViewDialog,
        showDeleteDialog, setShowDeleteDialog, setShowFilesModal,
        setOpenUploadFileDialog,
        setOpenApproveDialog } = useShared();


    useEffect(() => {
        if (!auth.hasRole([1, 2, 4, 17])) {
            return navigate("/db/notAllowed")
        }
    }, [])


    const getUnion = async () => {
        try {
            const res = await http.get('api/settings');
            console.log('Get union ', res);
            if (res.data.success) {
                const data = res?.data?.data;
                setUnion(data);
                setGeneratePDF(true)
            }
        } catch (error) {
            console.log("Union fetch error ", error);
        }
    }

    const handleMenu = (model, flag = false) => {
        console.log("handleMenu ", model, flag);
        if (flag === 'delete') {
            setModel(model)
            setShowDeleteDialog(!showDeleteDialog)
        }
        if (flag === 'edit') {
            setModel(model)

            navigate(`/db/tariffs/0/new_tariff/${model.id}`, { state: { model } })
            //  setShowNewModelDialog(true)
        }
        if (flag === 'view') {
            setModel(model)
            setShowViewDialog(true)
        }

        if (flag === 'pdf') {
            getUnion();
            setModel(model)



        }
        if (flag === "upload file") {
            console.log("upload file");
            setModel(model)
            setOpenUploadFileDialog(pre => !pre)
        }

        if (flag === "approve") {
            console.log(flag);
            if (auth.hasRole([1, 2])) {
                setModel(model)
                setOpenApproveDialog(pre => !pre)
            }

        }
    };

    const openFilesDialog = (model) => {
        if (model?.attachments?.length > 0) {
            setModel(model)
            setShowFilesModal(true)
        }
    }



    const handleViewDialog = (obj) => {
        return [
            { l: 'Name', v: obj?.name },
            { l: 'Type', v: obj?.parent?.label },
            { l: 'Description', v: obj?.description },
            { l: 'Added by', v: obj?.user?.full_name },
            { l: 'Status', v: obj?.status },
            { l: 'Last Update', v: com.ddmmyyhhmmA(obj?.updated_at) },
        ]
    }

    const getTableData = () => {
        const data = models?.data
        return (<><tbody className=''>
            {data?.map((r, i) => {
                return (<Fragment key={r.id}>
                    {
                        <tr key={r.id}>
                            {/*  <td >{models?.from + i}</td> */}

                            <th>{r?.row_number}</th>
                            <th>{r?.id}</th>
                            <th> {r?.company ? r?.company?.name_af : r?.name} -  ({r?.tariff_number})</th>

                            <td >
                                {r?.items?.map((item, j) => {
                                    return (<span key={j} className='ml-1'>{item?.category ? item?.category?.label : item?.from_name}{j < r?.items?.length - 1 && <span >،</span>} </span>)
                                })}
                                <p>{r.tariff_type?.value==96?'$':'؋'} {com.NumberFormatter(r?.amount)} </p>
                                <APopover v={{ data: itemsPopup(r?.items, r.tariff_type?.value==96?'$':'؋'), className: "mt-3 ", btn: '!bg-deep-purple-900/20 ', iconCss: '!text-deep-purple-500' }} />
                            </td>

                            <td>

                                {r.aviza_date && <span>  {com.dateConvert(r?.aviza_date, false)}</span>}
                                <Chip onClick={() => handleMenu(r, r?.status === 0 ? "upload file" : r?.status === 1 ? "approve" : '')} className='capitalize text-center cursor-pointer px-1' variant="ghost" size="sm" color={r.status === 0 && r.attachments?.length === 0 ? 'gray'
                                    : r.status === 1 ? 'orange'
                                        : r.status === 2 ? 'green' : 'red'}
                                    value={r.status === 0 ? 'لطفا آويز بانکی آپلود کنيد'
                                        : r.status === 1 ? 'منتظر تاييد'
                                            : r.status === 2 ? 'تکمیل شد'
                                                : 'رد شد'} />

                                {r.description && <span>  {r.description}</span>}
                            </td>
                            <td className='text-center'> <span className=' cursor-pointer text-blue-600' onClick={() => openFilesDialog(r)}>({r.attachments?.length})</span></td>

                            <td style={{ direction: 'ltr' }}>
                                {com.dateConvert(r?.created_at, false, true)}
                                <p>{r?.user?.full_name}</p>
                            </td>
                            <td >
                                <AMenu v={{ handleMenu: (row, flag) => handleMenu(row, flag), model: r, callFrom: 'tariffs' }} />

                            </td>
                        </tr>}</Fragment>
                )
            })}
        </tbody></>)
    }

    const getSizeUnit = (items) => {
        return items?.length > 0 && (items[0]?.category?.value === 90 || items[0]?.category?.value === 91 || items[0]?.category?.value === 92) ? 'کيلوگرم' : 'متراژ'
    }


    const itemsPopup = (items, currency) => <table style={{ direction: 'rtl' }} className=" gTable  ">
        <thead >
            <tr className='!bg-deep-purple-900/20 !text-deep-purple-500'>
                <th>#</th>
                <th>نام جنس</th>
                <th>{getSizeUnit(items)}</th>
                <th> مقدار پول</th>
                <th>نوعيت</th>
            </tr>
        </thead>
        <tbody >
            {items?.map((item, i) => (
                <tr key={i + 1}>
                    <td>{1 + i}</td>
                    <td>{item?.category?.label} </td>
                    <td> {item?.quantity} </td>
                    <td>{currency}{com.NumberFormatter(item?.tariff_amount)} </td>
                    <td> {item?.quantity_type}</td>

                </tr>
            ))}
        </tbody>
    </table>

    const downloadPDF = (url) => {
        setGeneratePDF(pre => !pre)
        window.open(url)
        return null
    }


    return (
        <div>
            {generatePDF && <QRGenerator valueString={`ID: ${model?.id} - Account: ${union?.bank_account} - Amount: ${model?.amount} AFN`} documentId={model?.id} />}
            {/*   {generatePDF && <BlobProvider document={<TariffPdf v={{ model, com, http, Num2persian, }} />}
                fileName={'Tariff.pdf'}>
                {({ blob, url, loading, error }) => {
                    return (<> {loading ? <ASpinner /> : url ? downloadPDF(url) : null} </>)
                }}
            </BlobProvider>} */}

            <MainSection v={{
                handleViewDialog,
                newModelInputFields: [{ test: "new page" }],
                searchInputFields,
                TABLE_HEAD,
                breadcrumbs,
                tableData: getTableData(),
                addNewItemTitle: "تعرفه جديد",
                tableTitle: 'لست تعرفه‌ها',
                mUrl: { delete: 'tariffs', create: 'tariffs', getAll: 'tariffsAdvanceSearch' },
                modelName: { name: 'tariffs', af: 'تعرفه‌ها' },
                attachName: 'Tariff',
                modelScreen: '',
                newModelDialogClassName: "h-[90%]",
                searchData: { company_id: location?.state?.company_id, tariff_id_number: id },
                csv: { csvHeaders, show: true }
            }} />

            <ToastContainer />

            {generatePDF && <PDFGenerateModal v={{ modelName: 'Tariff', union }} />}

        </div>

    )

}
